<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                    id="input-name"
                    label="ФИО"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="name"
                        v-model="item.name"
                        type="text"
                        placeholder="Name"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-phone"
                    label="Телефон"
                    label-for="phone"
                    description=""
            >
                <b-form-input
                        id="phone"
                        v-model="item.phone"
                        type="text"
                        placeholder="Phone"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-email"
                    label="E-mail"
                    label-for="email"
            >
                <b-form-input
                        id="email"
                        v-model="item.email"
                        type="email"
                        placeholder="Email"
                ></b-form-input>
            </b-form-group>

            <p v-if="item.image">
                <img :src="this.axios.defaults.baseImageURL + item.image" class="image-cart" alt="">
            </p>
            <input type="file" id="image" ref="image" v-on:change="handleFileUpload()"/>

            <div class="buttons">
                <b-button type="submit">Обновить</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                item: {},
                image: null,
                errors: [],
                loading: false
            }
        },

        mounted() {
            if (this.$route.params.id) {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/managers/' + this.$route.params.id)
                    .then(response => {
                        this.item = response.data.manager
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false
                })
            }
        },

        methods: {
            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.item.name) this.errors.push("ФИО обязателен.");
                if(!this.item.email) this.errors.push("Email обязателен.");
                if(!this.item.phone) this.errors.push("Номер обязателен.");
            },

            onSubmit(e){
                this.checkForm(e)
                e.preventDefault()
                let formData = new FormData();
                formData.append('item', JSON.stringify(this.item));
                formData.append('image', this.image);
                formData.append('_method', 'PUT');

                if (this.errors.length === 0){
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/managers/' + this.$route.params.id, formData)
                        .then(response => {
                            if (response.data.message === 'success') {
                                this.$router.push({name: 'AdminManagers', params: {message: 'Менеджер успешно обновлен'}})
                            }else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            handleFileUpload() {
                this.image = this.$refs.image.files[0];
            }
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/managers/edit.vue